import { CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetCompanies =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await PostFunction({
        data: {},
        Route: UrlApi.companies.get, // Use from UrlApi
        showalert: false,
        state: getState,
        dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageCompanies =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const bodyFormData = new FormData();
      
      if (editMode && values?.id) {
        bodyFormData.append("id", values.id);
      }
      
      if (values.title) bodyFormData.append("title", values.title.trim());
      
      // Handle image upload
      if (values.image) {
        if (values.image instanceof File) {
          bodyFormData.append("image", values.image);
        } else if (typeof values.image === "string") {
          // Existing image URL
          bodyFormData.append("image_url", values.image);
        }
      }

      // Use ternary to select correct URL
      const route = editMode ? UrlApi.companies.edit : UrlApi.companies.add;
      
      const response = await PostFunction({
        data: bodyFormData,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditCompanies =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const formData = new FormData();
      formData.append("id", id);
      formData.append(nameFailed, dataFailed);
      
      const response = await PostFunction({
        data: formData,
        Route: UrlApi.companies.edit, // Use from UrlApi
        showalert: true,
        state: getState,
        isMultipart: nameFailed === "image",
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteCompanies =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { idscompanies: id },
        Route: UrlApi.companies.delete, // Use from UrlApi
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };